// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  'Visit the guide for more information: ',
  'https://vite-ruby.netlify.app/guide/rails',
);

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from 'javascripthotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from 'javascriptrails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import 'mapbox-gl/dist/mapbox-gl.css';

import 'javascript/vendor/initialisers.js';

// This is for compatibility with libraries that expect a global variable named `global` (like autocomplete.js)
window.global = window;

import 'javascript/vendor/slick_carousel/index.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'javascript/analytics/sentry.js';
import 'javascript/config/config.js';
import 'javascript/analytics/facebook_pixel.js';
import 'javascript/support_chats/freshdesk_live_chat.js';
import 'javascript/support_chats/fresh_chat.js';

import '@hotwired/turbo-rails';

import 'javascript/compatibility/turbolinks_scroll_fix';
import 'javascript/compatibility/template_tag';

import 'javascript/compatibility/polyfills';

import 'javascript/analytics/google_analytics_tracking';

import 'foundation-sites/dist/js/plugins/foundation.core';

import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard'; // for accordion
import 'foundation-sites/dist/js/plugins/foundation.util.triggers'; // for sticky

import 'foundation-sites/dist/js/plugins/foundation.accordion';
import 'foundation-sites/dist/js/plugins/foundation.sticky';

import 'javascript/config/init-foundation';

import 'javascript/components/detect-mobile';
import 'javascript/components/sessions';
import 'javascript/components/ticket-accordion';
import 'javascript/components/sticky-fallback';
import 'javascript/components/purchase-flash';

import {
  onTurboBeforeVisit,
  onTurboSubmitStart,
  onAnchorClicked,
  onTurboLoad,
} from 'javascript/utils/turbolinks_polyfills';

import { registerStimulusControllers } from 'javascript/utils/utils';

$(document).on('click', onAnchorClicked);
$(document).on('turbo:before-visit', onTurboBeforeVisit);
$(document).on('turbo:submit-start', onTurboSubmitStart);
$(document).on('turbo:load', onTurboLoad);

import { Application } from 'stimulus';

const application = Application.start();

const consumerControllers = import.meta.glob(
  'javascript/controllers/consumer_portal/**/*_controller.js',
  { eager: true },
);
registerStimulusControllers({
  controllers: consumerControllers,
  portal: 'consumer_portal',
  application,
});

const sharedControllers = import.meta.glob('javascript/controllers/shared/*', {
  eager: true,
});
registerStimulusControllers({
  controllers: sharedControllers,
  portal: 'shared',
  application,
});

if (window.nextGen) {
  const consumerNextGenControllers = import.meta.glob(
    'javascript/controllers/consumer_portal_next_gen/**/*_controller.js',
    { eager: true },
  );
  registerStimulusControllers({
    controllers: consumerNextGenControllers,
    portal: 'consumer_portal_next_gen',
    application,
  });
}
